import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/global.css";
import "./styles/components.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Elemento #root não encontrado no documento.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
